var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var template = require('../templates/document.ejs');
Backbone.$ = $;

module.exports = Backbone.View.extend({
  /**
   *
   */
  initialize: function (options) {
    _.bindAll(this, 'render');
    this.logo = options.logo;
  },
  /**
   *
   */
  render: function () {
    this.$el.html(template({
      document: this.model.get('data').document,
      logo: this.logo
    }));
    return this;
  }
});
